import { Badge, Button, Icon, Tooltip } from '@infotech-soe/erp-ui-kit';
import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';
import { createUseStyles } from 'react-jss';
import { ConnectedProps, legacy_connect as connect } from 'react-redux';

import UniqueId from '../../../../../services/uid/UniqueId';
import { AppState } from '../../../../../store/reducers/root';
import {
  getDatasetCategoryId,
  getDatasetFieldsConditionsCount,
  getDatasetName,
} from '../../../../../store/selectors/dataset';
import categoryActions from '../../../../../store/slices/category';
import dataset from '../../../../../store/slices/dataset';

interface FieldsConditionsButtonProps {
  datasetId: UniqueId;
}

const mapStateToProps = (
  state: AppState,
  { datasetId }: FieldsConditionsButtonProps
) => ({
  categoryId: getDatasetCategoryId(state, datasetId),
  datasetName: getDatasetName(state, datasetId),
  fieldsConditionsCount: getDatasetFieldsConditionsCount(state, datasetId),
});

const mapDispatchToProps = {
  updateFieldsConditions: categoryActions.updateFieldsConditions,
  updateDataset: dataset.update,
};

const mergeProps = (
  sP: ReturnType<typeof mapStateToProps>,
  { updateFieldsConditions, updateDataset }: typeof mapDispatchToProps,
  { datasetId }: FieldsConditionsButtonProps
) => ({
  ...sP,
  onClick: (datasetName: string, categoryId: string) => {
    updateFieldsConditions({
      categoryId,
      datasetName,
      fieldsConditions: {},
    });
    updateDataset({ datasetId, forceDOMFocus: true });
  },
});

const connector = connect(mapStateToProps, mapDispatchToProps, mergeProps);

type FieldsConditionsButtonContainerProps = ConnectedProps<typeof connector>;

const messages = defineMessages({
  switchOff: {
    id: 'core.category.grid.filter.off',
    defaultMessage: 'Disable columns filter',
  },
});

const useStyles = createUseStyles({
  buttonWithBadge: {
    position: 'relative',
  },
  toolbarBadge: {
    position: 'absolute',
    top: 0,
    right: 6,
  },
});

const FieldsConditionsButton = ({
  categoryId,
  datasetName,
  fieldsConditionsCount,
  onClick,
}: FieldsConditionsButtonContainerProps): React.JSX.Element | null => {
  const classes = useStyles();

  return fieldsConditionsCount ? (
    <Tooltip label={<FormattedMessage {...messages.switchOff} />}>
      <Button
        className={classes.buttonWithBadge}
        variant="borderless"
        onClick={() => onClick(datasetName, categoryId)}
      >
        <Icon name="filter-column" size={20} />
        <Badge className={classes.toolbarBadge}>{fieldsConditionsCount}</Badge>
      </Button>
    </Tooltip>
  ) : null;
};

export default connector(FieldsConditionsButton);
